import React from 'react';
import CEO from './CEO/CEO';
import Members from './Members/Members';

const OurTeam = () => {
    return (
        <div className="my-5">
            <CEO/>
            <Members/>
        </div>
    );
};

export default OurTeam;